var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_660_6310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.26916 9.08648C7.26916 8.75193 6.99794 8.48071 6.66339 8.48071C6.32883 8.48071 6.05762 8.75193 6.05762 9.08648V13.9326C6.05762 14.2671 6.32883 14.5384 6.66339 14.5384C6.99794 14.5384 7.26916 14.2671 7.26916 13.9326V9.08648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.08673 8.48071C9.42128 8.48071 9.6925 8.75193 9.6925 9.08648V13.9326C9.6925 14.2671 9.42128 14.5384 9.08673 14.5384C8.75217 14.5384 8.48096 14.2671 8.48096 13.9326V9.08648C8.48096 8.75193 8.75217 8.48071 9.08673 8.48071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1153 9.08648C12.1153 8.75193 11.8441 8.48071 11.5096 8.48071C11.175 8.48071 10.9038 8.75193 10.9038 9.08648V13.9326C10.9038 14.2671 11.175 14.5384 11.5096 14.5384C11.8441 14.5384 12.1153 14.2671 12.1153 13.9326V9.08648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7598 3.28835V4.77187H1.19936C0.871635 4.77187 0.605957 5.03755 0.605957 5.36527C0.605957 5.693 0.871635 5.95868 1.19936 5.95868H2.44256L3.41563 15.6894C3.53697 16.9028 4.55802 17.8268 5.77747 17.8268H12.0498C13.2693 17.8268 14.2904 16.9028 14.4117 15.6894L15.3847 5.95868H16.6279C16.9556 5.95868 17.2213 5.693 17.2213 5.36527C17.2213 5.03755 16.9556 4.77187 16.6279 4.77187H13.0675V3.28835C13.0675 2.14129 12.1376 1.21143 10.9906 1.21143H6.83673C5.68967 1.21143 4.7598 2.14129 4.7598 3.28835ZM6.83673 2.39824C6.34514 2.39824 5.94662 2.79676 5.94662 3.28835V4.77187H11.8807V3.28835C11.8807 2.79676 11.4822 2.39824 10.9906 2.39824H6.83673ZM14.192 5.95868L13.2308 15.5713C13.17 16.178 12.6596 16.64 12.0498 16.64H5.77747C5.16775 16.64 4.65722 16.178 4.59655 15.5713L3.63529 5.95868H14.192Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_660_6310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.d5009ad249593536026cecc419525ff4.svg";
export { ForwardRef as ReactComponent };